<script setup lang="ts">
    /**
     * Hero Widget
     * has the legacy name BackgroundHeader in the cms
     */
    import type { HeroData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    defineProps<IWidgetProps<HeroData>>();
</script>

<template>
    <mol-hero
        :hero-data="data"
        :is-first-hero="componentIndex === 0"
        class="cms-background-header" />
</template>
